import DanhMucCuocThanhTraTrung from './DanhMucCuocThanhTraTrung.jsx'
import DanhMucTongHopThanhTra from './DanhMucTongHopThanhTra.jsx'

export {
  DanhMucCuocThanhTraTrung,
  DanhMucTongHopThanhTra
}


// WEBPACK FOOTER //
// ./src/components/modules/thanh-tra-trung/index.js